import { render, staticRenderFns } from "./exchangeCodeManage.vue?vue&type=template&id=136d7dc8&scoped=true"
import script from "./exchangeCodeManage.vue?vue&type=script&lang=js"
export * from "./exchangeCodeManage.vue?vue&type=script&lang=js"
import style0 from "./exchangeCodeManage.vue?vue&type=style&index=0&id=136d7dc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d7dc8",
  null
  
)

export default component.exports